import { create } from "zustand";
import { persist } from "zustand/middleware";

import { isUserUsing12HourFormat } from "utils/date";

type TimeFormatType = "12" | "24" | "system";

type TimeSettingsStorage = {
  timeFormat: TimeFormatType;
};

type TimeSettingsStore = TimeSettingsStorage & {
  setTimeFormat: (format: TimeFormatType) => void;
  getResolvedTimeFormat: () => "12" | "24";
};

const DEFAULT_VALUES: TimeSettingsStorage = {
  timeFormat: "system",
};

const useTimeSettingsStore = create<TimeSettingsStore>()(
  persist(
    (set, get) => ({
      ...DEFAULT_VALUES,
      setTimeFormat: (format: TimeFormatType) => {
        set({ timeFormat: format });
      },
      getResolvedTimeFormat: () => {
        const state = get();
        if (state.timeFormat === "system") {
          return isUserUsing12HourFormat() ? "12" : "24";
        }
        return state.timeFormat;
      },
    }),
    {
      name: "datetime-settings-store",
      partialize: (state) => ({
        timeFormat: state.timeFormat,
      }),
    }
  )
);

export default useTimeSettingsStore;
